import { useSearchParams } from '@remix-run/react';
import { AuctionCard } from '~/components/auction-card';
import CustomPagination from '~/components/custom-pagination';
import { getAuctionsList } from '~/services/api/auctions';

interface PastAuctionsProps {
  auctions: Awaited<ReturnType<typeof getAuctionsList>>;
}

export default function PastAuctions({ auctions }: PastAuctionsProps) {
  const [searchParams, setSearchParams] = useSearchParams();

  const limit = parseInt(searchParams.get('limit') ?? '12');
  const currentPage = auctions.page;
  const totalPages = Math.ceil(auctions.totalCount / limit);

  return (
    <>
      <div className="mb-5 mt-2 flex flex-col">
        <h1 className="text-2xl font-semibold">Past Auctions</h1>
        <span className="text-sm text-slate-600">{auctions.totalCount} auctions found</span>
      </div>

      <div className="my-4 h-[1px] bg-slate-200" />

      <div className="mb-4 grid gap-4 sm:grid-cols-2 md:grid-cols-4">
        {auctions.list.map((auction, index) => (
          <AuctionCard key={index} auction={auction} />
        ))}
      </div>

      <CustomPagination
        limit={limit}
        totalCount={auctions.totalCount}
        currentPage={currentPage}
        totalPages={totalPages}
        onPrevPage={() => {
          searchParams.set('page', (currentPage - 1).toString());
          setSearchParams(searchParams, {
            preventScrollReset: true,
          });
        }}
        onNextPage={() => {
          searchParams.set('page', (currentPage + 1).toString());
          setSearchParams(searchParams, {
            preventScrollReset: true,
          });
        }}
        onPageChange={(page) => {
          searchParams.set('page', page);
          setSearchParams(searchParams, {
            preventScrollReset: true,
          });
        }}
        onLimitChange={(limit) => {
          searchParams.set('limit', limit);
          setSearchParams(searchParams, {
            preventScrollReset: true,
          });
        }}
      />
    </>
  );
}
